import { IFilterablePaginatedSection } from "@faire/web-api/indigofair/data/IFilterablePaginatedSection";
import { Column } from "@faire/web/slate/Layout";
import React from "react";

import { SDUIComponentRenderer } from "@faire/retailer/components/SDUI/__internal__/SDUIComponentRenderer";
import { SDUISectionInstanceRendererProps } from "@faire/retailer/components/SDUI/__internal__/types";
import { SDUIFilterRowRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/FilterBar/SDUIFilterRowRenderer";
import { SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/LoadingSkeleton/SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton";
import { SDUIFilterablePaginatedSectionGridLoadingSkeleton } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/LoadingSkeleton/SDUIFilterablePaginatedSectionGridLoadingSkeleton";
import { useFilterablePaginatedSectionQuery } from "@faire/retailer/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/useFilterablePaginatedSectionQuery";

export const FilterablePaginatedSectionComponentsColumn: React.FC<
  Omit<SDUISectionInstanceRendererProps, "section"> & {
    filterablePaginatedSection: IFilterablePaginatedSection;
  }
> = ({
  filterablePaginatedSection,
  componentRenderers,
  sectionLoggingData,
}) => {
  const {
    isFilterLoading,
    isFilteredComponentsFetching,
    isFilteredComponentsLoading,
    isFilteredComponentsRefetching,
    filteredComponentsData,
  } = useFilterablePaginatedSectionQuery(filterablePaginatedSection);

  return (
    <Column style={{ width: "100%" }}>
      {/* show full loading skeleton on first load */}
      {isFilteredComponentsLoading ? (
        <>
          <SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton />
          <SDUIFilterablePaginatedSectionGridLoadingSkeleton />
        </>
      ) : null}

      {/* continue showing the filter bar (if it exists) with a loading skeleton
      while data is refetched */}
      {isFilteredComponentsRefetching ? (
        <>
          {filteredComponentsData?.components
            ?.filter((component) => component.filter_bar_component)
            .map((component) => {
              return (
                <SDUIFilterRowRenderer
                  key={component.id}
                  component={component}
                  sectionLoggingParams={sectionLoggingData}
                  isFilterLoading={isFilterLoading}
                />
              );
            })}
          <SDUIFilterablePaginatedSectionGridLoadingSkeleton />
        </>
      ) : null}

      {!isFilteredComponentsFetching
        ? filteredComponentsData?.components?.map((component) => {
            if (component.filter_bar_component) {
              return (
                <SDUIFilterRowRenderer
                  key={component.id}
                  component={component}
                  sectionLoggingParams={sectionLoggingData}
                  isFilterLoading={isFilterLoading}
                />
              );
            }
            return (
              <SDUIComponentRenderer
                key={component.id}
                component={component}
                componentRenderers={componentRenderers}
                sectionLoggingParams={sectionLoggingData}
                // TODO(FD-201761): add handling for UPLT (loadTimingRef)
                isPrimaryContent
              />
            );
          })
        : null}
    </Column>
  );
};
